/* ═══════════════════════════════════════════════════
   FIGTEK INDUSTRY — THEME JS v1.0
═══════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {
  // ── NAV ──
  const nav = document.getElementById('site-nav');
  if (nav) {
    const u = () => nav.classList.toggle('scrolled', window.scrollY > 60);
    u(); window.addEventListener('scroll', u, { passive: true });
  }
  window.toggleMenu = function () {
    const m = document.getElementById('mobile-menu');
    if (!m) return;
    m.classList.toggle('open'); document.body.classList.toggle('menu-open');
  };
  // ── REVEAL ──
  const obs = new IntersectionObserver(e => e.forEach(x => { if (x.isIntersecting) x.target.classList.add('visible'); }), { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  // ── SLIDESHOW ──
  initSlideshow();
  // ── CAROUSEL ──
  initCarousel('car-outer','car-track','car-prev','car-next','car-dots');
  // ── STRIP ──
  initStrip('strip-outer','strip-track');
  // ── GALLERY ──
  initGallery();
  // ── SEARCH ──
  const so = document.getElementById('search-overlay');
  const si = document.getElementById('search-input');
  const ob = document.getElementById('search-open-btn');
  const cb = document.getElementById('search-close-btn');
  if (ob) ob.addEventListener('click', () => { so.classList.add('open'); setTimeout(() => si && si.focus(), 80); });
  if (cb) cb.addEventListener('click', () => so.classList.remove('open'));
  if (so) { so.addEventListener('click', e => { if (e.target === so) so.classList.remove('open'); }); document.addEventListener('keydown', e => { if (e.key === 'Escape') so.classList.remove('open'); }); }
});

function initSlideshow() {
  const slides = document.querySelectorAll('.slide');
  const dotsEl = document.getElementById('slideshow-dots');
  if (!slides.length) return;
  let cur = 0, timer;
  function goTo(i) {
    slides[cur].classList.remove('active'); cur = (i + slides.length) % slides.length; slides[cur].classList.add('active');
    if (dotsEl) dotsEl.querySelectorAll('.slideshow-dot').forEach((d, j) => d.classList.toggle('active', j === cur));
  }
  function next() { goTo(cur + 1); }
  function startTimer() { clearInterval(timer); timer = setInterval(next, 5500); }
  slides[0].classList.add('active');
  if (dotsEl) slides.forEach((_, i) => { const d = document.createElement('button'); d.className = 'slideshow-dot' + (i === 0 ? ' active' : ''); d.setAttribute('aria-label', 'Slide ' + (i+1)); d.addEventListener('click', () => { goTo(i); startTimer(); }); dotsEl.appendChild(d); });
  const bp = document.getElementById('slideshow-prev'); const bn = document.getElementById('slideshow-next');
  if (bp) bp.addEventListener('click', () => { goTo(cur - 1); startTimer(); });
  if (bn) bn.addEventListener('click', () => { goTo(cur + 1); startTimer(); });
  startTimer();
  let sx = 0; const ss = document.querySelector('.hero-slideshow');
  if (ss) { ss.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true }); ss.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { dx < 0 ? next() : goTo(cur-1); startTimer(); } }); }
}

function initCarousel(outerId, trackId, prevId, nextId, dotsId) {
  const outer = document.getElementById(outerId); const track = document.getElementById(trackId); const dotsEl = document.getElementById(dotsId);
  if (!outer || !track) return;
  const cards = Array.from(track.querySelectorAll('.product-card')); if (!cards.length) return;
  let cur = 0, offsetX = 0, dragging = false, dragStartX = 0, dragStartOff = 0, hasDragged = false;
  const GAP = 24;
  const vis = () => window.innerWidth < 700 ? 1 : window.innerWidth < 1100 ? 2 : 3;
  const cw = () => (cards[0] ? cards[0].offsetWidth + GAP : 0);
  const pages = () => Math.max(1, cards.length - vis() + 1);
  const maxOff = () => -(cw() * (cards.length - vis()));
  const move = (px, anim) => { track.style.transition = anim ? 'transform .45s cubic-bezier(.25,.46,.45,.94)' : 'none'; track.style.transform = `translateX(${px}px)`; };
  function buildDots() {
    if (!dotsEl) return; dotsEl.innerHTML = '';
    for (let i = 0; i < pages(); i++) { const d = document.createElement('button'); d.className = 'carousel-dot' + (i === cur ? ' active' : ''); d.setAttribute('aria-label', 'Page ' + (i+1)); d.addEventListener('click', () => go(i)); dotsEl.appendChild(d); }
  }
  function go(idx) {
    cur = Math.max(0, Math.min(idx, pages() - 1)); offsetX = Math.max(maxOff(), Math.min(0, -cw() * cur)); move(offsetX, true);
    if (dotsEl) dotsEl.querySelectorAll('.carousel-dot').forEach((d, i) => d.classList.toggle('active', i === cur));
  }
  const bp = document.getElementById(prevId); const bn = document.getElementById(nextId);
  if (bp) bp.addEventListener('click', () => go(cur - 1));
  if (bn) bn.addEventListener('click', () => go(cur + 1));
  outer.addEventListener('mousedown', e => { dragging = true; dragStartX = e.clientX; hasDragged = false; dragStartOff = offsetX; outer.classList.add('is-dragging'); });
  window.addEventListener('mousemove', e => { if (!dragging) return; const dx = e.clientX - dragStartX;if (Math.abs(dx) > 5) {hasDragged = true;} move(Math.max(maxOff(), Math.min(0, dragStartOff + e.clientX - dragStartX)), false); });
  window.addEventListener('mouseup', e => { if (!dragging) return; dragging = false; outer.classList.remove('is-dragging'); const dx = e.clientX - dragStartX; offsetX = Math.max(maxOff(), Math.min(0, dragStartOff + e.clientX - dragStartX)); if (!hasDragged) {offsetX = dragStartOff;move(offsetX, false);return;}go(Math.max(0, Math.min(pages()-1, Math.round(-offsetX/cw())))); });
  outer.addEventListener('touchstart', e => { dragStartX = e.touches[0].clientX; dragStartOff = offsetX; }, { passive: true });
  outer.addEventListener('touchmove', e => { move(Math.max(maxOff(), Math.min(0, dragStartOff + e.touches[0].clientX - dragStartX)), false); }, { passive: true });
  outer.addEventListener('touchend', e => { offsetX = Math.max(maxOff(), Math.min(0, dragStartOff + e.changedTouches[0].clientX - dragStartX)); go(Math.max(0, Math.min(pages()-1, Math.round(-offsetX/cw())))); });
  buildDots(); window.addEventListener('resize', () => { cur = 0; buildDots(); go(0); });
}

function initStrip(outerId, trackId) {
  const outer = document.getElementById(outerId); const track = document.getElementById(trackId);
  if (!outer || !track) return;
  const slides = track.querySelectorAll('.strip-slide:not([aria-hidden])'); const count = slides.length; if (!count) return;
  const SLIDE_W = 600 + 16; const SET_W = SLIDE_W * count;
  let pos = 0, paused = false, dragging = false, dragStartX = 0, dragStartPos = 0;
  track.style.transform = 'translateX(0px)';
  (function tick() { if (!dragging && !paused) { pos -= 0.55; if (Math.abs(pos) >= SET_W) pos += SET_W; track.style.transform = `translateX(${pos}px)`; } requestAnimationFrame(tick); })();
  outer.addEventListener('mouseenter', () => { paused = true; }); outer.addEventListener('mouseleave', () => { if (!dragging) paused = false; });
  outer.addEventListener('mousedown', e => { dragging = true; paused = true; dragStartX = e.clientX; dragStartPos = pos; outer.classList.add('is-dragging'); });
  window.addEventListener('mousemove', e => { if (!dragging) return; let p = dragStartPos + (e.clientX - dragStartX); if (p > 0) p -= SET_W; if (p < -SET_W) p += SET_W; pos = p; track.style.transform = `translateX(${pos}px)`; });
  window.addEventListener('mouseup', () => { if (!dragging) return; dragging = false; paused = false; outer.classList.remove('is-dragging'); });
  outer.addEventListener('touchstart', e => { dragging = true; paused = true; dragStartX = e.touches[0].clientX; dragStartPos = pos; }, { passive: true });
  outer.addEventListener('touchmove', e => { if (!dragging) return; let p = dragStartPos + (e.touches[0].clientX - dragStartX); if (p > 0) p -= SET_W; if (p < -SET_W) p += SET_W; pos = p; track.style.transform = `translateX(${pos}px)`; }, { passive: true });
  outer.addEventListener('touchend', () => { dragging = false; paused = false; });
}

function initGallery() {
  const mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('.pp-gallery__thumb').forEach(t => {
    t.addEventListener('click', function () {
      if (this.dataset.src && mainImg) { mainImg.style.opacity = '0'; const src = this.dataset.src; setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 200); }
      document.querySelectorAll('.pp-gallery__thumb').forEach(x => x.classList.remove('active')); this.classList.add('active');
    });
  });
  const qi = document.getElementById('qty-input');
  if (qi) {
    document.getElementById('qty-minus').addEventListener('click', () => { const v = parseInt(qi.value, 10); if (v > 1) qi.value = v - 1; });
    document.getElementById('qty-plus').addEventListener('click', () => { const v = parseInt(qi.value, 10); if (v < 99) qi.value = v + 1; });
  }
}
/*mobile sub menu*/
function toggleMobileMachines() {
  const item = document.querySelector('.mobile-machines');

  if (item) {
    item.classList.toggle('is-open');
  }
}